import React, { useEffect, useState, useMemo } from 'react'
import { makeStyles, createStyles, Tab, Tabs, AppBar, Box } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { getOrderPage } from 'src/store/slices/userSlice'
import OrderCard from 'src/mobile/components/Order/OrderCardPc'
import { MOBILE_HEADER_HEIGHT } from 'src/mobile/utils/constant'
import { Virtuoso } from 'react-virtuoso'
import Loading from 'src/mobile/components/Loading'
import { useTranslation } from 'react-i18next'
import { getDoctorList } from 'src/store/slices/testCenterSlice'
import { ORDER_STATUS } from 'src/utils/constant'
import { ReactComponent as ViewAllIcon } from 'src/mobile/assets/icons/Home_all.svg'
import { useHistory } from 'react-router-dom'
import { buttonClick } from 'src/utils/trackingCode'

const useStyles = makeStyles((theme) =>
  createStyles({
    appBar: {
      top: theme.spacing(MOBILE_HEADER_HEIGHT),
    },
    viewAllbtn: {
      width: theme.spacing(42.75),
      height: theme.spacing(7),
      background: theme.palette.secondary.main,
      borderRadius: theme.spacing(1),
      padding: '16px 24px',
      textAlign: 'center',
      justifyContent: 'center',
      margin: '0 auto',
      color: 'white',
      fontSize: 18,
      fontWeight: 600,
      marginBottom: theme.spacing(24),
      display: 'flex',
    },
    viewAllbtnIcon: {
      marginTop: theme.spacing(0.4),
      marginLeft: theme.spacing(1),
    },
    tab: {
      width: 60,
      fontSize: 14,
      margin: 10,
      height: 40,
      minWidth: 100,
      background: '#F9FAFB',
      borderRadius: 8,
      fontWeight: 600,
    },
    selected: {
      background: '#f2512d',
    },
    indicator: {
      display: 'none',
    },
    textColorInherit: {
      // color: '#111827',
      '&.Mui-selected': {
        color: '#fff',
      },
    },
  }),
)

const ORDER_LIST_TYPE = [
  {
    label: 'options.order_list_types.0',
  },
  {
    label: 'options.order_list_types.2',
  },
  {
    label: 'options.order_list_types.1',
  },

  {
    label: 'options.order_list_types.3',
  },
]

const OrderList = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [value, setValue] = useState(0)
  const history = useHistory()

  const { orderList, orderListStatus } = useSelector((state) => state.user)

  const setOrderList = () => {
    return dispatch(getOrderPage({ page: 1, size: 1000 }))
  }

  useEffect(() => {
    setOrderList()
  }, [])

  const handleChange = (e, newValue) => setValue(newValue)

  const tabOrderList = useMemo(() => {
    if (value === 2) return orderList?.filter((order) => order?.payStatus === ORDER_STATUS.PENDING_PAYMENT)
    if (value === 1) return orderList?.filter((order) => order?.payStatus === ORDER_STATUS.PAID)
    if (value === 3)
      return orderList?.filter(
        (order) =>
          order?.payStatus === ORDER_STATUS.REFUNDED ||
          order?.payStatus === ORDER_STATUS.PENDING_REFUND ||
          order?.payStatus === ORDER_STATUS.APPROVAL_SUCCEED ||
          order?.payStatus === ORDER_STATUS.APPROVAL_FAILED ||
          order?.payStatus === ORDER_STATUS.REFUND_FAILED,
      )
    return orderList
  }, [orderList, value])
  const { allDoctorList } = useSelector((state) => state.testCenter)
  useEffect(() => {
    !allDoctorList?.length && dispatch(getDoctorList())
  }, [])

  const getAvatar = (id) => {
    return allDoctorList?.find((value) => value.id === id)?.avatar
  }

  return (
    <Box minHeight={600}>
      <AppBar className={classes.appBar} elevation={0} position="sticky" color="inherit">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="order list tabs"
          classes={{
            indicator: classes.indicator,
          }}
        >
          {ORDER_LIST_TYPE.map((item) => (
            <Tab
              key={item.label}
              label={t(item.label)}
              classes={{
                root: classes.tab,
                selected: classes.selected,
                textColorInherit: classes.textColorInherit,
              }}
            />
          ))}
        </Tabs>
      </AppBar>
      {tabOrderList?.length ? (
        <Box height={1100}>
          <Virtuoso
            data={tabOrderList}
            itemContent={(index, order) => (
              <OrderCard
                order={order}
                key={order?.orderNumber}
                avatar={getAvatar(order.doctorId)}
                setOrderList={setOrderList}
              />
            )}
          />
        </Box>
      ) : (
        <Box mt={5}>
          <Loading title={t('tips.no_booking')} status={orderListStatus} fontSize={23} />
          {value === 0 && (
            <Box
              className={classes.viewAllbtn}
              onClick={() => {
                buttonClick('EH_MyAccount_MyBooking_Book', 'EH_MyAccount_MyBooking_Book')
                history.push('/ProductList')
              }}
            >
              <Box>{t('glossary.promotion.to_order')}</Box>
              <ViewAllIcon className={classes.viewAllbtnIcon} />
            </Box>
          )}
        </Box>
      )}
    </Box>
  )
}

export default OrderList
